import template from './statusPanel.html';

export default function statusPanel() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template,
    bindToController: true,
    controllerAs: '$ctrl',
    controller: 'StatusPanelController',
    scope: {
      panelId: '='
    }
  };
}
